module.exports = __webpack_public_path__ + "img/logo_partial.45422183.png";